import Login from "pages/AuthPage/components/Login/Login";

export default Login;
